/** @jsxImportSource theme-ui */
import { Box, Text, Flex, Heading } from 'theme-ui';
import React from 'react';
import { Formik } from 'formik';
import { usePostDiscountAgreementsMutation } from '@/store/apiService';
import { toast } from 'react-toastify';
import { DiscountAgreementForm } from './DiscountAgreementForm';
import ConnectDiscountAgreement from './ConnectDiscountAgreement';
import { getErrorMessage } from '@/utils/helpers';

type Props = {
    companyId: string;
    onSubmitSuccess?: () => void;
};

export type FormValues = {
    _articleType: string;
    Name: string;
    Description: string;
    ValidFrom: string;
    DiscountPeriod: {
        Length?: {
            Unit: string;
            Value: number;
        };
    };
    ChargePlanDiscounts: {
        ChargePlanId?: string;
        ProductGroupDiscounts?: {
            ProductGroupId: string;
            ProductPricingDiscounts: {
                ProductId: string;
                DiscountType: string;
                UnitPriceDiscount: number;
            };
        };
    };
};

const CreateDiscountAgreement: React.FC<Props> = ({
    companyId,
    onSubmitSuccess = () => {},
}: Props) => {
    const [createDiscountAgreement, createDiscountAgreementState] =
        usePostDiscountAgreementsMutation();

    const initialValues: FormValues = {
        _articleType: '4',
        Name: '',
        Description: '',
        ValidFrom: '',
        DiscountPeriod: {},
        ChargePlanDiscounts: {
            ChargePlanId: '',
        },
    };

    return (
        <>
            <Flex backgroundColor="Background" sx={{ flexDirection: 'column', borderRadius: 'sm' }}>
                <Flex
                    p="2"
                    sx={{
                        gap: 2,
                        '@media only screen and (max-width:60em)': {
                            flexDirection: 'column',
                        },
                        borderRadius: 'sm',
                    }}
                >
                    <Box
                        sx={{
                            flexBasis: '50%',
                            borderRadius: 'sm',
                            borderStyle: 'solid',
                            borderWidth: '1px',
                            borderColor: 'gray.2',
                            alignSelf: 'flex-start',
                        }}
                        p="3"
                    >
                        <Formik
                            initialValues={initialValues}
                            enableReinitialize
                            onSubmit={(values, { resetForm, setErrors, setSubmitting }) => {
                                return createDiscountAgreement(values)
                                    .unwrap()
                                    .then((res) => {
                                        onSubmitSuccess();
                                    })
                                    .catch((err) => {
                                        setSubmitting(false);
                                        toast.error(getErrorMessage(err), { autoClose: 5000 });
                                    });
                            }}
                        >
                            {(formProps) => {
                                return (
                                    <>
                                        <DiscountAgreementForm
                                            additionalErrors={createDiscountAgreementState.error}
                                            {...formProps}
                                        />
                                    </>
                                );
                            }}
                        </Formik>
                    </Box>
                </Flex>
            </Flex>
        </>
    );
};

export default CreateDiscountAgreement;
